<template>
<div class="test">
<b-table
        :data="force_units"
        :columns="columns"
        :checked-rows.sync="internal_units"
        checkable
        :customIsChecked="checked"
        checkbox-position="right">
        <template slot="bottom-left"> 
            <b>Total checked</b>: {{ internal_units.length }}
        </template>
        
    </b-table>
</div>
    
</template>

<script>
export default {
    props: ['units_selected','force_units'],
    data() {
        return {
            internal_units: this.units_selected,
            columns: [
                { field: 'name', label: 'Name', },
                { field: 'type', label: 'Unit' },
                { field: 'battlefield_role', label: 'Role' },
                { field: 'size', label: 'Size' },
                { field: 'rank', label: 'Rank' },
                { field: 'power_rating', label: 'Power', centered: true },
                { field: 'crusade_pts', label: 'Crusade Pts', centered: true },
            ], 
        }            
    },
    methods: {
        checked(one,two) { return one.uid == two.uid },            
    },
    watch: {
        internal_units(now,before) {
            console.debug('internal_units:\n',before, "\n → \n",now)
            this.$emit('update:units_selected', now)
        },
        force_units(now,before) { console.debug('force_units:\n',before, "\n → \n",now)},
        units_selected(now,before) { 
            console.debug('units_selected:\n',before, "\n → \n",now)
            this.internal_units = now 
        }
    }
}
</script>